export enum AnnouncementPhase {
	Phase1 = 1,
	Phase2 = 2,
	Phase3 = 3,
}

export interface MarketId {
	isoCountry: string
	isoRegion: string
	countryName: string
	regionName: string
}

export interface PhaseInfo {
	enabled: boolean
	phase: AnnouncementPhase
	market?: MarketId
	startAtUtc?: string
	ianaTimeZone?: string
}

export interface AnnouncementConfig {
	announcementType: string
	messageKeyPrefix: string
}

export interface AnnouncementProvider {
	getPhaseInfo(phase: AnnouncementPhase, residential: string, geo: string): PhaseInfo | null
}

export interface KeyValueStorage {
	getItem(key: string): string | null
	setItem(key: string, value: string): void
	removeItem(key: string): void
	clear(): void
}

export interface ModalDeps {
	showModal: (opts: { header: string; message: string; htmlId?: string }) => void
	t: (key: string, params?: Record<string, string | number>) => string
	getNow?: () => Date
	storage?: KeyValueStorage
}
